module.exports = __webpack_public_path__ + "img/1.8727ce7e.jpg";